import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
// const BASE_URL = "http://localhost:5000";
const DummyForm = () => {
	const [token, setToken] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [link, setLink] = useState("");
	const [duration, setDuration] = useState("");
	const [message, setMessage] = useState(false);
	const [error, setError] = useState(false);
	const [messageData, setMessageData] = useState("");
	const [errorData, setErrorData] = useState("");
	const [expiredAt, setExpiredAt] = useState("");

	const handleFields = async (e) => {
		e.preventDefault();
		await fetch(BASE_URL + "/dummyToken", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ email, password }),
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				if (data) {
					if (data.token) {
						setToken(data.token);
					}
					if (data.link) {
						setLink(data.link);
					}
					if (data.message) {
						setDuration(data.message);
					}
				}
			});
	};

	function checkToken() {
		fetch(BASE_URL + "/dummyTokenVerify", {
			method: "GET",
			headers: { "Content-Type": "application/json", token },
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);

				if (data.message) {
					setMessage(true);
					setMessageData(data.message.exp);
					setError(false);
				} else {
					setError(true);
					setErrorData(data.error.message);
					setExpiredAt(data.error.expiredAt);
					setMessage(false);
				}
			});
	}

	return (
		<>
			<form onSubmit={handleFields}>
				<div class="form-group">
					<label for="exampleInputEmail1">Email address</label>
					<input
						type="email"
						class="form-control"
						id="exampleInputEmail1"
						aria-describedby="emailHelp"
						placeholder="Enter email"
						onChange={(e) => {
							setEmail(e.target.value);
						}}
					/>
					<small id="emailHelp" class="form-text text-muted">
						We'll never share your email with anyone else.
					</small>
				</div>
				<div class="form-group">
					<label for="exampleInputPassword1">Password</label>
					<input
						type="password"
						class="form-control"
						id="exampleInputPassword1"
						placeholder="Password"
						onChange={(e) => {
							setPassword(e.target.value);
						}}
					/>
				</div>

				<button type="submit" class="btn btn-primary">
					Submit
				</button>

				{message ? (
					<p>Your Token will expire in : {messageData}</p>
				) : null}
				{error ? (
					<p>
						Your Token is Expired {errorData} & Your Token is
						Expired At: {expiredAt}{" "}
					</p>
				) : null}
				{token != "" ? (
					<p>
						Your link is : {link}
						<br /> And is Valid till {duration}
					</p>
				) : null}
			</form>
			<button onClick={() => checkToken()} class="btn btn-primary">
				Check Token
			</button>
		</>
	);
};

export default DummyForm;
